import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Spinner } from "@/components/ui/Spinner";
import { CartProduct } from "./CartProduct";
import { CheckoutContent } from "./CheckoutContent";
import { useContext, useState } from "react";
import { CartContext } from "../context/cart";
import { UserContext } from "../context/user";
import toast from "react-hot-toast";
import { Icon } from "@iconify/react";
import { Delete, Get, Post, Put } from "../api/api";
import { hasFeature } from "../lib/features";
import {
  SwipeableList,
  SwipeableListItem,
  SwipeAction,
  TrailingActions,
} from 'react-swipeable-list';
import 'react-swipeable-list/dist/styles.css';
import { useForm } from "react-hook-form";

export function Cart({ refetch = () => { } }) {
  const [client, setClient] = useState(null);
  const [searchClient, setSearchClient] = useState(false);
  const [clients, setClients] = useState([]);
  const [checkoutmodal, setCheckout] = useState(false);
  const [loading, setLoading] = useState(false);
  const { cart, setCart, comanda, setComanda } = useContext(CartContext);
  const { user } = useContext(UserContext);
  const [saveTicket, setSaveTicket] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const { register, handleSubmit, reset, setValue, watch } = useForm({
    defaultValues: { name: '', location: '', notes: '', delivery: false, time: 0 }
  });

  const hasComandasPack = hasFeature(user, "hosteleria_comandas");
  const units = cart.reduce((acc, product) => acc + product.quantity, 0);
  const total = cart.reduce((acc, product) => acc + (product?.custom_price * product?.quantity), 0);

  const cleanCart = () => {
    setCart([]);
    setComanda(false);
  };

  const handleSold = async () => {
    if (comanda) {
      await Delete({ request: '/comandas/' + comanda.id + '?shop_id=' + localStorage.getItem('shop_id') });
      setComanda(false);
      refetch();
    }

    if (localStorage.getItem("selected_comanda")) {
      let comanda = localStorage.getItem('selected_comanda');
      let comandas = JSON.parse(localStorage.getItem('comandas'));
      delete comandas[comanda];
      localStorage.setItem('comandas', JSON.stringify(comandas));
      localStorage.removeItem('selected_comanda');
    }

    setCart([]);
  };

  const saveComanda = async () => {
    if (comanda) {
      setLoading(true);
      let request = await Put({
        request: '/comandas/' + comanda.id + '?shop_id=' + localStorage.getItem('shop_id'),
        data: { cart: JSON.stringify(cart) }
      });
      setLoading(false);
      if (request.success) {
        toast.success('Comanda actualizada correctamente');
      } else {
        toast.error('Ha ocurrido un error');
      }
    } else {
      setSaveTicket(true);
    }
  };

  const saveNewTicket = async (values) => {
    let newComanda = {
      name: values.name,
      notes: values.notes,
      time: values.time || 0,
      location: values.location,
      delivery: values.delivery ? 1 : 0,
      cart: JSON.stringify(cart),
      notify: true,              // <-- para que el backend cree la notificación y la app la imprima sola
    };
    await Post({
      request: '/comandas?shop_id=' + localStorage.getItem('shop_id'),
      data: newComanda
    });
    setSaveTicket(false);
    toast.success('Comanda guardada correctamente');
    setCart([]);
    reset();
  };

  const searchClients = async () => {
    if (!searchValue) return;
    let result = await Get({ request: `/client?search=${searchValue}` });
    setClients(result.clients);
  };

  return (
    <>
      {/* Checkout Sheet */}
      <Sheet open={checkoutmodal} onOpenChange={setCheckout}>
        <SheetContent side="bottom" className="h-full p-0 flex flex-col overflow-hidden">
          <SheetHeader className="px-4 py-2.5 border-b shrink-0">
            <SheetTitle className="text-lg">Finalizar venta</SheetTitle>
          </SheetHeader>
          <div className="flex-1 min-h-0">
            <CheckoutContent
              items={cart}
              onClose={() => setCheckout(false)}
              searchClient={() => setSearchClient(true)}
              client={client}
              onSold={handleSold}
            />
          </div>
        </SheetContent>
      </Sheet>

      {/* Search Client Sheet */}
      <Sheet open={searchClient} onOpenChange={setSearchClient}>
        <SheetContent className="w-[500px] sm:max-w-[500px]">
          <SheetHeader>
            <SheetTitle>Buscar Cliente</SheetTitle>
            {client && (
              <Button variant="destructive" size="sm" onClick={() => { setClient(false); setSearchClient(false); }}>
                Quitar
              </Button>
            )}
          </SheetHeader>
          <div className="mt-4">
            <div className="flex gap-2">
              <Input
                placeholder="Buscar cliente"
                value={searchValue}
                onChange={e => setSearchValue(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && searchClients()}
              />
              <Button variant="outline" onClick={searchClients}>
                <Icon icon="mdi:magnify" />
              </Button>
            </div>
          </div>
          <div className="divide-y mt-4">
            {clients.map((c) => (
              <div key={c.id} className="flex justify-between items-center py-3">
                <div className="text-xl font-semibold">{c.name}</div>
                <Button variant="outline" onClick={() => { setClient(c); setSearchClient(false); }}>
                  Seleccionar
                </Button>
              </div>
            ))}
          </div>
        </SheetContent>
      </Sheet>

      {/* Save Comanda Sheet */}
      <Sheet open={saveTicket} onOpenChange={setSaveTicket}>
        <SheetContent className="w-[500px] sm:max-w-[500px]">
          <SheetHeader>
            <SheetTitle>Guardar Comanda</SheetTitle>
          </SheetHeader>
          <form onSubmit={handleSubmit(saveNewTicket)} className="space-y-4 mt-4">
            <div className="space-y-2">
              <Label>Nombre</Label>
              <Input {...register("name")} placeholder="Nombre" />
            </div>
            <div className="space-y-2">
              <Label>Mesa</Label>
              <Input {...register("location", { required: true })} placeholder="Mesa" />
            </div>
            <div className="space-y-2">
              <Label>Notas</Label>
              <Textarea {...register("notes")} />
            </div>
            <div className="flex items-center justify-between">
              <Label>Delivery</Label>
              <Switch checked={watch("delivery")} onCheckedChange={v => setValue("delivery", v)} />
            </div>
            <div className="space-y-2">
              <Label>Minutos para recoger</Label>
              <Input type="number" {...register("time")} />
            </div>
            <div className="flex justify-end">
              <Button type="submit" variant="default">Crear Comanda</Button>
            </div>
          </form>
        </SheetContent>
      </Sheet>

      {/* Cart Content */}
      <div className="w-full h-full p-2 animate-fade-left animate-once">
        <div className="w-full h-full min-h-0 border shadow-sm rounded-md overflow-hidden flex flex-col bg-white">
          {/* Header */}
          <div className="px-3 pt-3 pb-2 border-b space-y-2 shrink-0">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <div className="text-xl font-bold text-neutral-900">Venta</div>
                {comanda ? <Badge variant="success">Comanda</Badge> : null}
              </div>
              <Button
                variant="outline"
                onClick={cleanCart}
                disabled={cart?.length == 0}
                className="h-9 px-3 text-sm"
              >
                <Icon icon="mdi:trash-can-outline" className="text-base mr-1" />
                Limpiar
              </Button>
            </div>
            <button
              onClick={() => setSearchClient(true)}
              className="w-full flex items-center gap-3 rounded-xl bg-blue-50 hover:bg-blue-100 active:scale-[0.98] px-3 py-2 text-left transition-all"
            >
              <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-blue-600 text-white shrink-0">
                <Icon icon="material-symbols:person" className="text-xl" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-[11px] font-medium text-blue-700/70 uppercase tracking-wide">Cliente</span>
                <span className="block text-base font-semibold text-neutral-900 truncate">{client?.name || "Público en general"}</span>
              </span>
              <Icon icon="mdi:chevron-right" className="text-xl text-blue-600 shrink-0" />
            </button>
          </div>

          {/* Products list */}
          <div data-bottom-nav-scroll className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-2 pb-1 pt-2 flex flex-col">
            <Spinner spinning={loading}>
              {cart.length === 0 ? (
                <div className="m-auto flex flex-col items-center text-center text-neutral-400 my-auto pt-10">
                  <Icon icon="mdi:cart-outline" className="text-6xl mb-3" />
                  <p className="text-base font-semibold text-neutral-500">Carrito vacío</p>
                  <p className="text-sm">Toca un producto para añadirlo</p>
                </div>
              ) : (
                <SwipeableList>
                  {cart.map((product) => (
                    <SwipeableListItem
                      className="w-full mb-1.5"
                      key={product.custom_id}
                      trailingActions={
                        <TrailingActions>
                          <SwipeAction destructive={true} onClick={() => setCart(prev => prev.filter((p) => p.custom_id !== product.custom_id))}>
                            <div className="w-full h-full bg-red-500 flex items-center justify-center gap-1">
                              <Icon icon="mdi:trash-can" className="text-white text-xl" />
                              <span className="text-white text-sm font-semibold">Eliminar</span>
                            </div>
                          </SwipeAction>
                        </TrailingActions>
                      }
                    >
                      <div className="w-full animate-fade animate-once [animation-duration:200ms]">
                        <CartProduct product={product} />
                      </div>
                    </SwipeableListItem>
                  ))}
                </SwipeableList>
              )}
            </Spinner>
          </div>

          {/* Footer */}
          <div className="shrink-0 border-t bg-neutral-50 px-3 py-3 space-y-2.5">
            <div className="flex items-end justify-between gap-4">
              <div>
                <div className="text-xs text-neutral-500">{units} unidades · {cart.length} artículos</div>
                <div className="text-xs font-medium uppercase tracking-wide text-neutral-500">Total</div>
              </div>
              <div className="text-2xl font-extrabold text-neutral-900 leading-none">{total.toFixed(2)}€</div>
            </div>
            <div className="grid gap-1.5">
              <Button disabled={cart.length == 0} className="w-full h-12 text-lg font-bold" variant="default" size="lg" onClick={() => setCheckout(true)}>
                <Icon icon="mdi:cart-check" className="mr-2 text-xl" />
                Finalizar venta
              </Button>
              {hasComandasPack && (
                <Button loading={loading} onClick={saveComanda} disabled={cart.length == 0} className="w-full h-11 text-base font-medium" variant="outline" size="lg">
                  <Icon icon={comanda ? "mdi:update" : "mdi:content-save-outline"} className="mr-2 text-lg" />
                  {comanda ? 'Actualizar Comanda' : 'Guardar Comanda'}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}